export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-compass-2d35b9f355b3cb4f3719e3f548dfa2f5.svg";